import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { TooltipProvider } from '@/components/ui/tooltip';
import { isApiError } from '@/lib/api';
import i18n from '@/lib/i18n';
import { ThemeProvider } from '@/lib/theme/theme';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        // 4xx are answers, not hiccups: retry only network/5xx, twice.
        retry: (count, error) => count < 2 && (!isApiError(error) || error.isNetwork || error.status >= 500),
      },
    },
  });
}

/** QueryClient, i18n (it/en), theme (dark/light/system) and tooltips. Auth lives in the router (src/routes/_app.tsx). */
export function Providers({ queryClient, children }: { queryClient: QueryClient; children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <TooltipProvider delayDuration={250}>{children}</TooltipProvider>
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
